import MaplibreDraw from 'maplibre-gl-draw';

// Pakai mode bawaan sebagai base
const Base = MaplibreDraw.modes.draw_polygon;

/**
 * Hapus vertex terakhir (logical, bukan titik penutup) + simpan ke redoStack
 */
function removeLastVertex(state, ctx) {
  if (!state || !state.polygon) return;

  // kalau sudah di batas aman (2), akhiri mode daripada paksa jadi 1
  if (state.currentVertexPosition <= 2) {
    // keluar ke simple_select, biarkan poligon dengan 2 titik “draft” (umum dipakai)
    ctx.changeMode('draw_polygon', { featureIds: [state.polygon.id] });

    // hapus feature sepenuhnya:
    ctx.deleteFeature([state.polygon.id]);
    return;
  }

  // …lanjutkan remove seperti punyamu
  const removeIndex = state.currentVertexPosition - 1;
  const ring = state.polygon.getCoordinates()[0] || [];
  const removed = ring[removeIndex];
  if (removed) state.__redoStack.push(removed);

  state.polygon.removeCoordinate(`0.${removeIndex}`);
  state.currentVertexPosition -= 1;

  // update titik penutup = copy titik pertama
  const first = state.polygon.getCoordinates()?.[0]?.[0];
  const closingPath = `0.${state.currentVertexPosition}`;
  if (first) state.polygon.updateCoordinate(closingPath, first[0], first[1]);
}

/**
 * Tambahkan kembali vertex terakhir yang di-undo (REDO)
 */
function redoLastVertex(state) {
  if (!state || !state.polygon) return;
  if (!state.__redoStack.length) return;

  const coord = state.__redoStack.pop();
  if (!coord) return;

  // Tambah di ujung ring (sebelum titik penutup)
  const insertIndex = state.currentVertexPosition; // posisi logical berikutnya
  // addCoordinate(path, lng, lat) tersedia di SimpleFeature
  state.polygon.addCoordinate(`0.${insertIndex}`, coord[0], coord[1]);

  // Naikkan posisi current
  state.currentVertexPosition += 1;

  // Perbarui titik penutup (copy titik pertama)
  const first = state.polygon.getCoordinates()[0][0];
  const closingPath = `0.${state.currentVertexPosition}`;
  if (first) state.polygon.updateCoordinate(closingPath, first[0], first[1]);
}

const DrawPolygonUndoRedo = {
  ...Base,
  _pendingPolygon: null,
  // clickOnVertex(state, e) {
  //   // Sebelum close polygon, simpan dulu datanya
  //   if (state.currentVertexPosition === 2) {
  //     const coords = state.polygon.coordinates[0];

  //     // Cek apakah click di vertex pertama (closing polygon)
  //     const firstPoint = coords.at(-1);
  //     const clickedCoords = [e.lngLat.lng, e.lngLat.lat];

  //     const px1 = this.map.project(firstPoint);
  //     const px2 = this.map.project(clickedCoords);
  //     const distance = Math.sqrt(
  //       Math.pow(px1.x - px2.x, 2) + Math.pow(px1.y - px2.y, 2)
  //     );

  //     if (distance < 12) {
  //       // Simpan polygon sebelum di-close
  //       this._pendingPolygon = state.polygon.toGeoJSON();
  //     }
  //   }

  //   return Base.clickOnVertex.call(this, state, e);
  // },
  clickOnVertex(state, e) {
    // Sebelum close polygon, simpan dulu datanya
    if (state.currentVertexPosition === 2) {
      const coords = state.polygon.coordinates[0];

      // Cek apakah click di vertex pertama (closing polygon)
      const firstPoint = coords.at(-1);
      const clickedCoords = [e.lngLat.lng, e.lngLat.lat];

      const px1 = this.map.project(firstPoint);
      const px2 = this.map.project(clickedCoords);
      const distance = Math.sqrt(
        Math.pow(px1.x - px2.x, 2) + Math.pow(px1.y - px2.y, 2)
      );

      if (distance < 12) {
        // Simpan polygon sebelum di-close
        this._pendingPolygon = state.polygon.toGeoJSON();
      }
    } else if (state.currentVertexPosition === 1) {
      this._pendingPolygon = state.polygon.toGeoJSON();
    }

    return Base.clickOnVertex.call(this, state, e);
  },
  onSetup(...args) {
    const state = Base.onSetup.apply(this, args);
    // Stack untuk redo (berisi koordinat dari titik yang dihapus dengan undo)
    state.__redoStack = [];
    return state;
  },

  // Override onClick supaya ketika user menambah titik baru, kita clear redoStack
  onClick(state, e) {
    const before = state.currentVertexPosition;
    const res = Base.onClick ? Base.onClick.call(this, state, e) : undefined;
    const after = state.currentVertexPosition;
    if (after > before) {
      // Ada titik baru ditambahkan → clear redo
      state.__redoStack = [];
    }
    return res;
  },

  // Tombol Trash → Undo satu titik (perilaku tambahan; default-nya hapus feature)
  onTrash(state) {
    removeLastVertex(state, this);
  },

  // Keyboard:
  //  - Ctrl/Cmd+Z      => Undo 1 titik
  //  - Ctrl/Cmd+Shift+Z => Redo 1 titik
  onKeyDown(state, e) {
    const key = e.key?.toLowerCase?.();
    const isMeta = e.ctrlKey || e.metaKey;

    if (key === 'enter') {
      const coords = state.polygon?.coordinates[0];


      // Validasi minimal 3 titik
      if (coords && coords.length <= 3 && coords.length >= 1) {
        const vertex_length = state.currentVertexPosition;
        const ghost = coords?.[vertex_length];
        const lastCoord = coords.at(-1);
        if (ghost && lastCoord[0] === ghost[0] && lastCoord[1] === ghost[1]) {
          const new_coords = state.polygon?.coordinates[0]?.filter(c => c[0] !== ghost[0] && c[1] !== ghost[1]);
          const geojson = state.polygon.toGeoJSON()
          geojson.geometry.coordinates[0] = new_coords;
          this._pendingPolygon = geojson; // Simpan polygon
        } else {
          this._pendingPolygon = state.polygon.toGeoJSON(); // Simpan polygon
        }

        // Change mode untuk trigger onStop
        return;
      }
    }

    if (isMeta && key === 'z' && !e.shiftKey) {
      e.preventDefault();
      removeLastVertex(state, this);
      return;
    }
    if (isMeta && key === 'z' && e.shiftKey) {
      e.preventDefault();
      redoLastVertex(state);
      return;
    }

    if (Base.onKeyDown) return Base.onKeyDown.call(this, state, e);
  },

  onStop(state) {
    if (this._pendingPolygon) {
      this.map.fire('draw.create', {
        features: [this._pendingPolygon]
      });
      this._pendingPolygon = null;
    }

    // Bersihkan stack ketika mode berakhir
    if (state) state.__redoStack = [];
    if (Base.onStop) Base.onStop.call(this, state);
  },
};

export default DrawPolygonUndoRedo;
